'use client';

import React, { useState } from 'react';
import { AddToListModal } from 'src/components/AddToListModal';
import { useProspectSelection } from 'src/context/prospects';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

const TableAddToListButton = () => {
  const {
    state: [newProviders],
    selectedRows: [rowsAreSelected, setRowsAreSelected],
  } = useProspectSelection();

  const [showAddProvidersDialog, setShowAddProvidersDialog] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`px-3.5 py-2 bg-white rounded-full outline outline-1 -outline-offset-1 outline-neutral-300 inline-flex justify-center items-center gap-2.5 ${
          newProviders.length
            ? 'hover:bg-neutral-50 cursor-pointer'
            : 'opacity-50 cursor-not-allowed'
        }`}
        onClick={() => setShowAddProvidersDialog(true)}
        data-testid="add-to-list-button"
        disabled={!newProviders.length}
      >
        <div className="flex justify-center items-center gap-1">
          <div className="w-4 h-4 left-0 overflow-hidden flex justify-center items-center">
            <Icon
              icon={faPlus}
              className={`w-3 h-3 ${
                newProviders.length ? 'text-neutral-600' : 'text-neutral-400'
              }`}
            />
          </div>
          <div className="justify-start text-primary text-sm font-semibold font-['Inter'] leading-tight">
            Add to List
          </div>
        </div>
      </button>
      <AddToListModal
        isOpen={showAddProvidersDialog}
        onClose={() => {
          setRowsAreSelected(!rowsAreSelected);
          setShowAddProvidersDialog(false);
        }}
        mode="add"
        providers={newProviders}
      />
    </>
  );
};

export default TableAddToListButton;
